<lay-main>
    <lay-header role="header"></lay-header>
</lay-main>

<div class="page-overlay" *ngIf="isPageLoading$ | async">
    <span class="page-loader"></span>
</div>

<global-error-popup></global-error-popup>